/* eslint-disable no-trailing-spaces */
// 是否定义
function isDef(v) {
    return v !== undefined && v !== null && v !== ''
}

// 千位分隔数据
function numFormat(val) {
    if (isDef(val)) {
        let reg = val.toString().indexOf('.') > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g
        return val.toString().replace(reg, '$1,')
    } else return ''
}


export  default { isDef, numFormat }
